import { useContext } from "react";

import { SettingsContext } from "../contexts/SettingsContext";

const useSettingsContext = () => {
  const context = useContext(SettingsContext);

  if (!context) throw new Error("Settings context must be use inside Provider");

  return context;
};

export default useSettingsContext;
